import { mapGetters } from 'vuex';
import mvtLinkList from '@/common/components/mvtlinklist/mvt-linklist.js';
import throttle from 'lodash/throttle';
export default {
    name: 'homePopularCities',
    components: {
        mvtLinkList,
    },
    computed: {
        ...mapGetters('glb', ['glb']),
        ...mapGetters('home', ['home']),
        getPopularCities() {
            return this.home.popularCityList || [];
        },
    },
    methods: {
        getScrollPX() {
            let scrollWidth = this.$refs.homePopularCitiesList.scrollWidth;
            let width = this.$refs.homePopularCitiesList.clientWidth;
            this.$refs.homePopularCitiesList.style.setProperty('--scroll-width', `${scrollWidth - width}px`);
        },
    },
    mounted() {
        requestAnimationFrame(() => {
            this.getScrollPX();
            this.$refs.homePopularCitiesList.style.setProperty('overflow-x', 'hidden');
        });
        window.addEventListener('resize', throttle(this.getScrollPX, 100));
    },
};
